export const PUBLIC_PAGE_ROUTE_DATA = {
  data: {
    ABOUT: {
      title: 'About Us - TopFan',
      description: `TopFan mission is to help independent creators and interest groups of all types and backgrounds
        create a direct connection with their most valued fans around the world. We believe creators should be discoverable,
        have financial sustainability, and directly own the relationship with their fans.`
    },
    PRICING: {
      title: 'TopFan - Pricing',
      description: `TopFan will always be 100% free for creators to directly engage with their best fans.
        If you decide to make money by offering paid content and merchandise to your fans, TopFan utilizes a 100% revenue
        share partnership model.`
    },
    PRIVACY_POLICY: {
      title: 'Privacy Policy - TopFan',
      description: `This Privacy Policy describes how TopFan, Inc. and its subsidiaries and affiliates
        (collectively, “TopFan,” or “we” or “us”, “our”) collect, use, and share Personal Information.`
    },
    CONTACT: {
      title: 'Contact Us - TopFan',
      description: `Contact Customer Support.`
    },
    HELP_FAQ: {
      title: 'Help Center & FAQ - TopFan',
      description: `How do I become a Creator? The first step is to register as a user here.
        Then you will be able to click the option in your preferences that says “Become a Creator”
        and follow the steps so you can be discovered by fans.`
    }
  },
  titles: {
    TERMS_CONDITIONS: 'TopFan - Terms & Conditions'
  }
} as const;
